import { LinkFieldValue, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { ProjectOverview as ProjectOverviewComponent } from 'src/components/ProjectOverview';

import { ComponentProps } from 'src/jss/lib/component-props';
import { Filter } from 'src/types';

export type ProjectOverviewFieldsItemProps = {
  city: { value: string };
  detailPage: { value: LinkFieldValue };
  endDate: { value: string };
  startDate: { value: string };
  typeOfWork: { value: string };
  workingArea: { value: string };
  regions: Filter[];
};

export type ProjectOverviewFieldsProps = {
  displayName: string;
  fields: ProjectOverviewFieldsItemProps;
  id: string;
  name: string;
  url: string;
};

export type ProjectOverviewProps = {
  fields: {
    items: ProjectOverviewFieldsProps[];
    title: { value: string };
    regionsFilter: Filter[];
  };
  params: { anchor: string };
} & ComponentProps;

const ProjectOverview = (props: ProjectOverviewProps) => {
  if (!props.fields) return null;

  return <ProjectOverviewComponent {...props} />;
};

export default withDatasourceCheck()<ComponentProps>(ProjectOverview);
